/**
 * @file src/views/VID/views/helpers/sanitizeAddresses.ts
 * @exports sanitizeAddresses
 * @summary Sanitizes and transforms address objects by extracting only the required fields for disclosure purposes.
 * @remarks Filters out unwanted properties and ensures only standard address fields are included. Returns empty array for null/undefined input.
 * @example
 * ```typescript
 * const rawAddresses = [
 *   { addressLineOne: '123 Main St', city: 'Seattle', extraField: 'unwanted', state: 'WA' }
 * ];
 * const clean = sanitizeAddresses(rawAddresses);
 * // Returns: [{ addressLineOne: '123 Main St', city: 'Seattle', state: 'WA' }]
 * ```
 */
import { DisclosureAddress } from "src/generated/graphql";

export const sanitizeAddresses = (addresses?: any[]): DisclosureAddress[] => {
	if (!addresses || addresses.length === 0) {
		return [];
	}
	return addresses.map(({ addressLineOne, addressLineTwo, city, country, postalCode, state }) => {
		return { addressLineOne, addressLineTwo, city, country, postalCode, state };
	});
};
